import { ContextStore, ExperimentStore } from 'bernie-plugin-mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { SearchResultsStore } from 'src/common/stores/search-results-store';

import { PackageType } from 'models/multi-item/multi-item-types';

import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

import { SearchForm } from 'src/common/components/common/search-form';

interface ChangeSearchFormProps {
  searchResults?: SearchResultsStore;
  multiItem?: MultiItemStore;
  context?: ContextStore;
  experiment?: ExperimentStore;
  isHidden?: boolean;
}

export const ChangeSearchForm: React.FunctionComponent<ChangeSearchFormProps> = inject(
  'searchResults',
  'multiItem',
  'context'
)(
  observer(({ searchResults, multiItem, context, isHidden = false }) => {
    const onUpdateResults = () => {
      if (searchResults) {
        searchResults.clearDefaultRequestFields();
        searchResults.shouldFetch = true;
      }
    };

    const { formatText } = useLocalization();
    const packageType = multiItem?.getPackageType() ?? undefined;

    const isMobile = context && context.deviceInformation && context.deviceInformation.mobile;
    const displayFields: string[] = React.useMemo(() => getDisplayFields(packageType), [packageType]);

    const ignoreFields = React.useMemo(() => ['startDate', 'endDate', 'partialStayStartDate', 'partialStayEndDate'], []);

    const searchFormProps = {
      model: searchResults && searchResults.searchCriteria,
      displayFields,
      ignoreFields,
      onUpdateResults,
      isMobile,
    };

    return (
      <UitkSpacing
        padding={{ small: { inline: 'two' }, medium: { inline: 'unset' } }}
        margin={{ block: 'two' }}
        data-stid="section-hotel-search"
        className={isHidden ? 'is-hidden' : ''}
      >
        <div>
          {multiItem?.isTouchedCart && !multiItem?.isPackageShoppingPath() && (
            <UitkSpacing margin={{ blockend: 'two' }}>
              <UitkText size={400} className="pwa-theme--grey-700" weight="bold">
                {formatText('hotels.searchResults.multiProperty.searchCriteria.header')}
              </UitkText>
            </UitkSpacing>
          )}
          <h2 className="is-visually-hidden">{formatText('hotels.infosite.availabilityWizard.changeSearch.a11yLabel')}</h2>
          <SearchForm {...searchFormProps} />
        </div>
      </UitkSpacing>
    );
  })
);

export const getDisplayFields = (packageType?: string) =>
  packageType && packageType !== PackageType.HC
    ? ['origin', 'destination', 'rooms', 'cabinClass', 'dateRange', 'directFlights', 'partialStayCheckbox', 'partialStayDateRange']
    : ['destination', 'dateRange', 'rooms', 'pickUpTime', 'dropOffTime'];
